import React from 'react';
// import logo from './logo.svg';
import "antd/dist/antd.min.css";
import Navbar from './components/Navbar';
import { BrowserRouter as Router } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/pages/Home';
import RentAHome from './components/pages/RentAHome';
import RentHome from './components/pages/RentHome';
import Footer from './components/Footer';
import SignUp from './components/pages/SignUp';
import Login from './components/pages/Login';
import {Logout} from './components/pages/Logout';
import Likes from './components/pages/Likes';
import LikedPlaces from './components/pages/LikedPlaces';
// import Profile from './components/pages/Profile';
import Bookings from './components/pages/Bookings';
import DocumentUpload from './components/pages/DocumentUpload';
import Dashboard from './components/pages/Dashboard';
import MyProfile from './components/pages/MyProfile';
import FindARoomate from './components/pages/FindARoomate';
import Partner from './components/pages/Partner';
import Landlord from './components/pages/Landlord';
import FAQ from './components/pages/FAQ';
import Careers from './components/pages/Careers';
import About from './components/pages/About';
import Contact from './components/pages/Contact';

import HomeApp from './components/pages/homeapp/index';
import HomeAppPayments from './components/pages/homeapp/payments';
import HomeAppOrders from './components/pages/homeapp/orders';
import HomeAppProfile from './components/pages/homeapp/profile';

function App() {
  return (
    <>
    <Router>
      <Helmet>
        <title>Bubble Living</title>
        <meta
          name="description"
          content="Apartment hunting made easy · Find Verified Roommates · Save on legal and agent fees · Speed up the renting process."
        />
        <meta
          name="keywords"
          content="Bubble Africa, Bubble Living, BubbleAfrica, BubbleLiving, Rent, Lagos, Houses in lagos, rent in lagos, affordable houses in lagos"
        />
      </Helmet>
      <Navbar />
      <Routes>
      
        <Route exact path='/' element={<Home />} />
        <Route exact path='/rent-a-home' element={<RentAHome />} />
        <Route exact path='/home' element={<RentHome />} />
        <Route exact path='/sign-up' element={<SignUp />} />
        <Route exact path='/login' element={<Login />} />
        <Route exact path='/logout' element={<Logout />} />
        <Route exact path='/likes' element={<Likes />} />
        <Route exact path='/likedplaces' element={<LikedPlaces />} />
        {/* <Route exact path='/profile' element={<Profile />} /> */}
        <Route exact path='/bookings' element={<Bookings />} />
        <Route exact path='/document-upload' element={<DocumentUpload />} />
        <Route exact path='/dashboard' element={<Dashboard />} />
        <Route exact path='/my-profile' element={<MyProfile />} />
        <Route exact path='/find-a-roommate' element={<FindARoomate />} />
        <Route exact path='/partner' element={<Partner />} />
        <Route exact path='/landlord' element={<Landlord />} />
        <Route exact path='/faq' element={<FAQ />} />
        <Route exact path='/careers' element={<Careers />} />
        <Route exact path='/about' element={<About />} />
        <Route exact path='/contact' element={<Contact />} />
        <Route exact path='/app-home' element={<HomeApp />} />
        <Route exact path='/app-payments' element={<HomeAppPayments />} />
        <Route exact path='/app-orders' element={<HomeAppOrders />} />
        <Route exact path='/app-profile' element={<HomeAppProfile />} />
      </Routes>
      <Footer />
      
    </Router>
    </>
  );
}

export default App;
